import React, { useState, useEffect } from 'react';
import WidgetItem from './WidgetItem';
import { GetServices } from '../../GeneralAPI';

import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';
import WidgetItemInternal from './WidgetItemInternal';
import Axios from 'axios';
import EmailMobileModal from '../../components/EmailMobileModal';

function WidgetList(props) {
	const [vaccineNo, setVaccineNo] = useState('');
	const [fileUpload, setFileUpload] = useState('');
	const [showModal, setShowModal] = useState(false);
	let langCode = 'en';
	function announceVisible(){
		const startDate = new Date('2022-12-01');
		const endDate = new Date('2023-01-01');
		var currentDate = new Date();
		if (startDate <= currentDate && endDate >= currentDate) {
			return true;
		} else {
			return false;
        }
    }
	if (props.activeLanguage !== undefined) {
		langCode = props.activeLanguage.code;
	}
	const [data, setData] = useState([]);
	useEffect(() => {
		GetServices().then(data => {
			setData(data);
			console.log(data);
			console.log(data.length > 0 && data[0].email == '');
			
			// Show modal if email is empty
			if (data.length > 0 && data[0].email == '') {
				setShowModal(true);
			}
		});
	}, [props.Lang]);
	const servicesInReact = [
		{
			name_en: 'Student Results',
			name_ar: 'نتائج الطالب',
			logo: 'results.jpg',
			link: '/results',
		},
		{
			name_en: 'Student Schedule',
			name_ar: 'جدول الطالب',
			logo: 'schedule.jpg',
			link: '/Schedule/General',
		},
		{
			name_en: 'Student Transcript',
			name_ar: 'السجل الدراسى',
			logo: 'transcript.jpg',
			link: '/transcript',
		},
		{
			name_en: 'Clinic Reservation',
			name_ar: 'حجز العيادة',
			logo: 'clinc.jpg',
			link: '/clinic',
		},
	];
	const onFileChange = event => {
    setFileUpload(event.target.files[0])
		// Update the state
 	  
	  };

	  const onFileUpload = () => {
    
		// Create an object of formData
		const formData = new FormData();
	  
		// Update the formData object
		formData.append(
		  "myFile",
		  fileUpload,
		  fileUpload.name
		);
	  
		// Details of the uploaded file
		console.log(fileUpload);
	  
		// Request made to the backend api
		// Send formData object
		Axios.post("api/Login/UploadJustFile", formData).then(x=> {
			alert('File is submitted successfully');
		});
	  };
	  
	const submitVaccineNo = () => {

		if(vaccineNo.length != 20)
		{
			alert("الرقم يجب ان يكون نكون من 20 رقم");
			return;
		}
		fetch('api/Login/SetVaccineNo/' + vaccineNo).then(response => {
			alert('تم الارسال بنجاح');
		});
	};
	return (
		
		<div class="row">
			<div class="col-12">

				{(announceVisible() &&
					<div class="note note-warning  note-with-right-icon m-b-15">
						<div class="note-icon"><i class="fas fa-bullhorn"></i></div>






						<div class="note-content  text-center" >
							<h4>
								<b>إعلان هام</b>
							</h4>

							<p>

							بمناسبة فعاليات الشمول المالي يمكنك فتح حساب بنكي ببنك قطر الأهلي الوطني QNB 


						</p>

						<a class="btn btn-primary btn-lg " target="_blank" href="https://www.qnbalahli.com/sites/qnb/qnbegypt/page/ar/arbeacustomer.html" >بالضغط هنا</a>
						<br/>
							<p>
							مع العلم بتواجد مندوبي البنك في فروع الاكاديمية المختلفة خلال الفترة من 1 ديسمبر الى 15 ديسمبر 2022 تسهيلا على ابنائنا الطلاب
							</p>

						</div>
					</div>
				)}




{/*			<div  class="note note-danger  note-with-right-icon m-b-15">*/}
{/*							<div class="note-icon"><i class="fas fa-bullhorn"></i></div>*/}

			
{/*					*/}{/* <div class="row" style={{ display: 'none'}} >*/}{/*
*/}{/*					<button onClick={submitVaccineNo} class="btn btn-primary">*/}{/*
*/}{/*							ارسال الرقم{' '}*/}{/*
*/}{/*						</button>*/}{/*
*/}{/*						<div class="col-6">*/}{/*
*/}{/*							<input*/}{/*
*/}{/*								pattern="[0-9]*"*/}{/*
*/}{/*								type="text"*/}{/*
*/}{/*								class="form-control "*/}{/*
*/}{/*								onChange={event => setVaccineNo(event.target.value.replace(/\D/, ''))}*/}{/*
*/}{/*								placeholder=""*/}{/*
*/}{/*								value={vaccineNo}*/}{/*
*/}{/*							></input>*/}{/*
*/}{/*						</div>*/}{/*
*/}{/*						<div class="col-1">*/}{/*
*/}{/*							<span></span>*/}{/*
*/}{/*						</div>*/}{/*

					
*/}{/*					</div> */}




{/*					<div class="note-content  text-center" >*/}
{/*						<h4>*/}
{/*							<b>إعلان هام</b>*/}
{/*						</h4>*/}
{/*						*/}{/* <p style={{}}>*/}{/*
*/}{/*						حرصا من الأكاديمية على صحة ابنائها الطلاب وجميع العاملين بها والوفاء بالتزامها نحو توفير اللقاح الخاص بفيروس كورونا من خلال التعاون المثمر مع وزارة الصحة بدولة المقر، فبرجاء الإنتباه والإلتزام بالخطة الموضوعة لتطعيم أسرة الأكاديمية (السادة أعضاء هيئة التدريس، والسادة العاملين بالأكاديمية والطلاب) بجميع المقار، حيث أن التطعيم إلزامى للحضور خلال فعاليات الفصل الدراسي الحالي (الأول ٢٠٢١ - ٢٠٢٢). */}{/*
*/}{/*هذا إلى جانب الإلتزام بكافة الإجراءات الاحترازية المتبعة وخاصة إرتداء الكمامات أثناء التواجد داخل مقار الأكاديمية، متمنين لكم دوام الصحة و وافر العافية.						*/}{/*
*/}{/*</p> */}
{/*						<p>الطلاب الأعزاء … في إطار حرص الأكاديمية العربية للعلوم والتكنولوجيا والنقل البحري على تطبيق الإجراءات الاحترازية لمواجهة فيروس كورونا، على جميع الطلاب وضع نسخة من استمارة إثبات الحصول على التطعيم من خلال بوابة الطلبة (بيانات تلقي تطعيم كورونا) في موعد اقصاه 3 فبراير 2022، وذلك حتى لا يتم حجب ظهور درجات الطالب.*/}
{/*							<br/>Dear students ... Within the Arab Academy for Science, Technology and Maritime Transport (AASTMT) implementation to the precautionary measures to confront the "corona virus", it should be noted that all AASTMT students must upload a copy of COVID-19 Vaccination Record Card (Proof of vaccination) through AASTMT Student Portal (Corona Vaccination Receipt Data), where the dead time will be on 3- 2- 2022, as to prevent the blocking of student's grades.</p>*/}
{/*						<hr />*/}
{/*						<p>*/}
{/*							في إطار حرص الأكاديمية على صحة العاملين وأبنائها الطلاب فقد تقرر توفير الجرعة التنشيطية الثالثة لمواجهة<br />*/}
{/*							Covid-19 لمن تخطى ستة أشهر على تلقيهم الجرعة الثانية، وذلك يومي:-<br />*/}
{/*							الأثنين 21 مارس 2022 بمقر الإدارة الطبية- أبي قير<br />*/}
{/*							الأثنين 28 مارس 2022 بمقر الإدارة الطبية- ميامي<br />*/}

{/*							</p>*/}
{/*						<div className="text-right">*/}
{/*							*/}{/* <a*/}{/*
*/}{/*								className="btn btn-default"*/}{/*
*/}{/*								target="_blank"*/}{/*
*/}{/*								href="https://www.facebook.com/1463704063876547/posts/2831555903758016/"*/}{/*
*/}{/*							>*/}{/*
*/}{/*								more info*/}{/*
*/}{/*							</a> */}
{/*						</div>*/}
{/*					</div>*/}
{/*				</div>*/}
{/*				*/}{/*<div  class="note note-warning m-b-15 "  >*/}
{/*				*/}{/*<div class="note-icon"><i class="fa fa-stethoscope"></i></div>*/}

{/*				*/}{/*	<div class="note-content">*/}
{/*				*/}{/*		<h4>*/}
{/*				*/}{/*			<b>Covid-19 Vaccine Card Details</b>*/}
{/*				*/}{/*		</h4>*/}
{/*				*/}{/*		<div class="row"   >*/}
{/*				*/}{/*			<div class="col-3">*/}
{/*				*/}{/*			<span>Upload Card</span>*/}
{/*				*/}{/*			</div>*/}
{/*				*/}{/*			<div class="col-9">*/}
{/*				*/}{/*			<input 		class="" type="file" onChange={onFileChange} />*/}

{/*				*/}{/*			</div>*/}
{/*				*/}{/*			<div class="col-12">*/}
{/*				*/}{/*				<br/>*/}
{/*				*/}{/*				<hr/>*/}
{/*				*/}{/*			</div>*/}
{/*				*/}{/*			<div class="col-4"></div>*/}
{/*				*/}{/*			<div class="col-4">*/}
{/*				*/}{/*				<button onClick={onFileUpload} class="btn btn-primary btn-lg btn-block">*/}
{/*				*/}{/*				Submit */}
{/*				*/}{/*				</button>*/}
{/*				*/}{/*			</div>*/}
{/*				*/}{/*			<div class="col-4"></div>*/}
{/*				*/}{/*			<div class="col-12 text-center">*/}
								
{/*				*/}{/*			</div>*/}
							
							

						
{/*				*/}{/*		</div>*/}
{/*				*/}{/*	</div>*/}
{/*				*/}{/*</div>*/}
				
		</div>
			<div class="col-12  col-sm-12 col-md-3"></div>
			<div class="col-12  col-sm-12 col-md-6 mb-3">
				<div id="carouselExampleInterval" class="carousel slide" data-ride="carousel">
					<div class="carousel-inner">
						{/*<div class="carousel-item  active" data-interval="15000">*/}
						{/*	<a href="https://aastmtic.aast.edu/MobileContent/lb/student.html?ref=studentportalweb" target="_blank">*/}
						{/*		<img src={`assets/img/widgets/mobileapp_min.png`} class="d-block w-100 rounded" alt="" />*/}
						{/*	</a>*/}
						{/*</div>*/}

						<div class="carousel-item  active" data-interval="30000">
							<a href="https://www.facebook.com/events/324437077276597" target="_blank">
								<img src={`assets/img/widgets/icpc.png`} class="d-block w-100 rounded" alt="" />
							</a>
						</div>
					{/*<div class="carousel-item "  data-interval="5000">*/}
					{/*		<a href={`assets/img/widgets/qnb1.png`} target="_blank">*/}
					{/*			<img src={`assets/img/widgets/qnb1.png`} class="d-block w-100 rounded" alt="" />*/}
					{/*		</a>*/}
					{/*	</div>*/}
						

					{/*	<div class="carousel-item  "  data-interval="5000">*/}
					{/*		<a href={`assets/img/widgets/qnb2.png`} target="_blank">*/}
					{/*			<img src={`assets/img/widgets/qnb2.png`} class="d-block w-100 rounded" alt="" />*/}
					{/*		</a>*/}
					{/*	</div>*/}
						{/*<div class="carousel-item"  data-interval="10000">*/}
						{/*	<a href={`assets/img/widgets/qnb1.png`} target="_blank">*/}
						{/*		<img src={`assets/img/widgets/vaccine.png`} class="d-block w-100 rounded" alt="" />*/}
						{/*	</a>*/}
						{/*</div>*/}
						{/*<div class="carousel-item " data-interval="5000">*/}
						{/*	<a href={`assets/img/widgets/corona.png`} target="_blank">*/}
						{/*		<img src={`assets/img/widgets/corona.png`} class="d-block w-100 rounded" alt="" />*/}
						{/*	</a>*/}
						{/*</div>*/}
				
					</div>
					<a class="carousel-control-prev" href="#carouselExampleInterval" role="button" data-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						<span class="sr-only">Previous</span>
					</a>
					<a class="carousel-control-next" href="#carouselExampleInterval" role="button" data-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
						<span class="sr-only">Next</span>
					</a>
				</div>
			</div>
			<div class="col-12  col-sm-12 col-md-3"></div>

			{/* Render modal for collecting email/mobile when missing */}
			{data.length > 0 && data[0].email == '' && (
				<EmailMobileModal
					show={showModal}
					onClose={() => setShowModal(false)}
					onSuccess={() => setShowModal(false)}
				/>
			)}
			{data.length > 0 &&
				data
					.filter(x => x.code == 9)
					.map((item, idx) => (
						<WidgetItem Lang={props.Lang} key={`${item.event_id || item.code || 'svc'}-${idx}`} {...item} />
					))}

			{data.length > 0 &&
				servicesInReact.map((item, idx) => (
					<WidgetItemInternal Lang={props.Lang} key={`${item.link}-${idx}`} {...item} />
				))}

			{data.length > 0 &&
				data
					.filter(x => x.code != 9 && x.code)
					.map((item, idx) => (
						<WidgetItem Lang={props.Lang} key={`${item.event_id || item.code || 'svc'}-${idx}`} {...item} />
					))}
		</div>
	);
}
export default withLocalize(WidgetList);



// WEBPACK FOOTER //
// ./src/pages/Home/WidgetList.js